<template>
    <div class="backgroud-white">
        <div class="text-center">
            <h4>添加课程</h4>
        </div>
        <div class="backgroud-gray-popup popup-content-area-small">
            <el-form label-width="100px">
                <el-form-item label="业务">
                    <el-select v-model="trainingCourse.TrainingCategoryId"  @change="getTrainingCourse" placeholder="请选择业务">
                        <el-option v-for="item in training.categories" :key="item.TrainingCategoryId" :label="item.TrainingCategoryName" :value="item.TrainingCategoryId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="校区">
                    <el-select v-model="trainingCourse.CampausId" placeholder="请选择校区" @change="checkAllInputs">
                        <el-option v-for="item in campaus" :key="item.Id" :label="item.Name" :value="item.Id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="课程">
                    <el-select v-model="trainingCourse.CourseId" placeholder="请选择课程" @change="checkAllInputs">
                        <el-option v-for="item in courses" :key="item.CourseId" :label="item.CourseName" :value="item.CourseId"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer popup-footer">
            <el-row>
                <el-col class="footer-right" :span="24">
                    <el-button :type="submitBtnClass" :disabled="saving" @click="onSaveTeacherTrainingCourses">确认添加</el-button>
                </el-col>
            </el-row>
        </div>
  </div>
</template>

<script>
import {
    saveTeacherTrainingCourse
} from "../service/teacherCourse.service.js"

import {
    getCampusList,
    getTrainingCourseList
} from "../service/common.service";

export default {
    data(){
        let validateCampus = (rule, value, callback) => {
            if (!this.trainingCourse.CampausId) {
                callback(new Error("请选择校区"));
            } else {
                callback();
            }
        };

        let validateCourse= (rule, value, callback) => {
            if (!this.trainingCourse.CourseId) {
                callback(new Error("请选择课程"));
            } else {
                callback();
            }
        };

        return {
            trainingCourse:{
                CampausId:"",
                TrainingCategoryId:"",
                CourseId:""
            },
            saving:true,
            errorMessage:"",
            showError:false,
            submitBtnClass:"info",
            courses:[],
            campaus:[],
            rules: {
                Course:[
                {
                    required: true,
                    validator: validateCourse,
                    trigger: "blur"
                }],
                Campus:[
                {
                    required: true,
                    validator: validateCampus,
                    trigger: "blur"
                }]
            }
        }
    },
    props:["training"],
    components:{

    },
    created() {
        this.trainingCourse.TrainingCategoryId = this.training.selectedCategory;
        this.getTrainingCourse();
        this.getCampus();
        this.checkAllInputs();
    },
    methods:{
        onSaveTeacherTrainingCourses(){
            this.saving = true;
            let data = {
                CourseId : this.trainingCourse.CourseId,
                CampausId : this.trainingCourse.CampausId ? this.trainingCourse.CampausId : 0,
                TrainingCategoryId : this.trainingCourse.TrainingCategoryId
            }

            let result = saveTeacherTrainingCourse(data).then(result => {
                if (!result.success) {
                    this.$message.error(result.message);
                    this.showError = true;
                } else {
                    this.$message("保存成功！");
                    this.showError = false;
                    this.$emit("closeAddCourse");
                }
                this.saving=false;
            });
        },
        getTrainingCourse(){
            //课程
            getTrainingCourseList({
                trainingCategoryId:this.trainingCourse.TrainingCategoryId
            }).then(res=>{
                this.courses = res.data;
                if(this.courses && this.courses.length > 0){
                    this.trainingCourse.CourseId = this.courses[0].CourseId;
                }
                this.checkAllInputs();
            });
        },
        getCampus(){
            //校区
            getCampusList().then(res=>{
                this.campaus = res.data;
            });
        },
        checkAllInputs() {
            if (!this.trainingCourse.TrainingCategoryId ||  
                !this.trainingCourse.CourseId) {
                
            }else{
                this.submitBtnClass = "primary";
                this.saving = false;
            }
        }
    },
    watch:{

    }
}
</script>


// WEBPACK FOOTER //
// src/components/addActiveCourse.vue